<template>
  <div class="page-content">
    <AttendancePagesHeading
      pageName="Disbursement Details"
    ></AttendancePagesHeading>

    <div class="card partner-card mb-3">
      <div class="card-header">
        Daily bill of {{ formatDateUsingMoment }}
        <div class="button-area">
          <div class="download-button">
            <i
              v-if="$userPermission.has('export-disbursement-transaction')"
              class="bi bi-download"
              @click="downloadExcelFile"
            ></i>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4 cell">
            <h6>Disbursed by</h6>
            <p>Accounts Team</p>
          </div>
          <div class="col-md-4 cell">
            <h6>Disbursed on</h6>
            <!-- <p>
              {{
                disbursementStatusDetails.disbursed_on
                  ? disbursementStatusDetails.disbursed_on
                  : 'N/A'
              }}
            </p> -->
            <p>{{ latestDisbursementDate }}</p>
          </div>
          <div class="col-md-4 cell">
            <h6>Disbursement Status</h6>
            <span
              :class="{
                'partner-badge': true,
                'rounded-pill': true,
                'pending-rectangle': totalDisbursementStatus == 'Pending',
                'disbursed-rectangle': totalDisbursementStatus == 'Disbursed',
                'partially-disbursed-rectangle':
                  totalDisbursementStatus == 'Partially Disbursed'
              }"
            >
              {{ totalDisbursementStatus }}
            </span>
            <!-- <p
              v-if="
                disbursementStatusDetails.pending ===
                disbursementStatusDetails.total
              "
              class="pending-rectangle"
            >
              Pending
            </p>
            <p
              v-if="
                disbursementStatusDetails.disbursed ===
                disbursementStatusDetails.total
              "
              class="disbursed-rectangle"
            >
              Disbursed
            </p>
            <p
              v-if="
                disbursementStatusDetails.disbursed !=
                disbursementStatusDetails.total
              "
              class="partially-disbursed-rectangle"
            >
              Partially Disbursed
            </p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="card partner-card">
      <div class="card-header">
        Partner Information
        <div class="button-area">
          <select
            class="form-select"
            v-model="filterValues.bill_type"
            style="width: 150px"
          >
            <option value="regular">Regular</option>
            <option value="gasbill">Gas Bill</option>
            <option value="backupbill">Backup Bill</option>
          </select>
          <select
            class="form-select"
            v-model="filterValues.payment_method"
            style="width: 150px"
          >
            <option value="bkash">bKash</option>
            <option value="bank">Bank</option>
          </select>
          <Multiselect
            style="width: 180px"
            v-model="selectFilter"
            :closeOnSelect="true"
            :options="filterOption"
            :createTag="true"
            :loading="true"
            placeholder="Select Filter"
          />
          <input
            type="search"
            class="form-control"
            v-model.lazy="searchValue"
            placeholder="Search"
            style="width: 180px"
          />
          <template v-if="$userPermission.has('disburse-transaction')">
            <button
              v-if="selected.length >= 1"
              type="button"
              class="btn btn-primary"
              @click="disbursementAmount"
            >
              Disburse
            </button>
            <button
              v-else
              class="btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#bulkDisburseFromExcelModal"
              style="white-space: nowrap"
            >
              <i class="bi bi-file-earmark-spreadsheet-fill"></i>
              Disburse
            </button>
          </template>
        </div>
      </div>
      <div class="card-body">
        <DefaultLoader v-if="isLoading"></DefaultLoader>
        <div class="table-responsive" v-else>
          <CustomDataTable
            :filteredData="filteredPaymentList"
            @fetchPaginatedData="fetchPaginatedData"
          >
            <table class="table partner-table">
              <thead>
                <tr>
                  <th class="ps-2">
                    <input
                      class="form-check-input"
                      v-show="checkAllPaymentDisbursed"
                      type="checkbox"
                      v-model="selectAll"
                    />
                  </th>
                  <th>Name</th>
                  <th>Phone No.</th>
                  <th>Bank Name</th>
                  <th>AC No.</th>
                  <th>Driver Name</th>
                  <th>Client</th>
                  <th>TR Id</th>
                  <th>Bill Type</th>
                  <th>Billing Week/Month</th>
                  <th>Payment Method</th>
                  <th>Payment (weekly)</th>
                  <th v-if="$userPermission.has('edit-transaction-id')">
                    Action
                  </th>
                  <th>Transaction ID</th>
                  <th>Disbursed On</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="paymentList.length > 0">
                  <template
                    v-for="list in paginatedFilteredPaymentList"
                    :key="list.bills_id"
                  >
                    <tr>
                      <td v-if="list.total_bill_requested_and_disbursed === 2">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="list.transaction_history_id"
                          disabled
                          checked
                        />
                      </td>
                      <td v-else>
                        <input
                          class="form-check-input"
                          type="checkbox"
                          v-model="selected"
                          :value="list.transaction_history_id"
                        />
                      </td>
                      <td>
                        {{
                          driverDetails.find(
                            (driver) => driver.user_code === list.user_code
                          )
                            ? driverDetails.find(
                                (driver) => driver.user_code === list.user_code
                              ).name
                            : 'No Name Found'
                        }}
                      </td>
                      <td>
                        {{
                          driverDetails.find(
                            (driver) => driver.user_code === list.user_code
                          )
                            ? driverDetails.find(
                                (driver) => driver.user_code === list.user_code
                              ).mobile
                            : 'No Number Found'
                        }}
                      </td>
                      <td>
                        <span v-if="list.payment_method === 'bank'">{{
                          list.bank_name ? list.bank_name : 'N/A'
                        }}</span>
                        <span v-else>{{
                          list.payment_method ? list.payment_method : 'N/A'
                        }}</span>
                      </td>
                      <td>{{ list.account_no ? list.account_no : 'N/A' }}</td>
                      <td>
                        {{
                          driverDetails.find(
                            (driver) => driver.user_code === list.driver
                          )
                            ? driverDetails.find(
                                (driver) => driver.user_code === list.driver
                              ).name
                            : 'No Name Found'
                        }}
                      </td>
                      <td>
                        {{
                          list.service_types?.search('B2C') >= 0
                            ? `B2C${list.company_codes ? ', ' : ''}`
                            : ''
                        }}
                        {{ list.company_codes }}
                      </td>
                      <td>
                        {{ list.tr_ids }}
                      </td>
                      <td>
                        <span
                          v-if="list.type && list.type === 'regular'"
                          class="partner-badge partner-badge-primary rounded-pill"
                          >{{ list.type }}</span
                        >
                        <span
                          v-else-if="list.type && list.type === 'gasbill'"
                          class="partner-badge partner-badge-pink rounded-pill"
                          >{{ list.type }}</span
                        >
                        <span v-else>N/A</span>
                      </td>
                      <td>
                        <span
                          v-if="
                            list.billing_trip_start_date ||
                            list.billing_trip_end_date
                          "
                        >
                          {{
                            list.billing_trip_start_date
                              ? $format.date(list.billing_trip_start_date)
                              : 'N/A'
                          }}
                          -
                          {{
                            list.billing_trip_end_date
                              ? $format.date(list.billing_trip_end_date)
                              : 'N/A'
                          }}
                        </span>
                        <span v-else>N/A</span>
                      </td>
                      <td>
                        {{ list.payment_method ? list.payment_method : 'N/A' }}
                      </td>
                      <td>
                        {{ floatingPointPlaces(list.debit, 2) }}
                        ৳
                      </td>
                      <td v-if="$userPermission.has('edit-transaction-id')">
                        <button
                          class="btn btn-xs btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#editBillModal"
                          @click="selectedPayment = list"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                      </td>
                      <td>
                        {{
                          list.transaction_code ? list.transaction_code : 'N/A'
                        }}
                      </td>
                      <td>
                        {{
                          list.disbursed_on
                            ? $format.dateTime(list.disbursed_on)
                            : 'N/A'
                        }}
                      </td>
                    </tr>
                  </template>
                </template>
                <tr v-else>
                  <td colspan="50" class="text-center text-danger">
                    No Data Found
                  </td>
                </tr>
              </tbody>
            </table>
          </CustomDataTable>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Disburse From Excel Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="bulkDisburseFromExcelModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <BulkDisburseFromExcel
          :paymentList="paymentList"
          @refreshData="getPaymentList"
        ></BulkDisburseFromExcel>
      </div>
    </div>
  </teleport>

  <!-- Edit Bill Modal -->
  <teleport to="body">
    <div
      class="modal fade partner-modal"
      id="editBillModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm">
        <EditBill
          :payment="selectedPayment"
          @refreshData="getPaymentList"
        ></EditBill>
      </div>
    </div>
  </teleport>
</template>

<script>
import Multiselect from '@vueform/multiselect';
import moment from 'moment';
import http from '../../config/axios';
import userService from '../../config/axiosUserService';
// import Pagination from '../pagination/Pagination';
import CustomDataTable from '../customDataTable/CustomDataTable.vue';
import AttendancePagesHeading from '../attendancePages/AttendancePagesHeading.vue';
import BulkDisburseFromExcel from './BulkDisburseFromExcel.vue';
import EditBill from './EditBill.vue';

export default {
  name: 'disburseDetails',
  components: {
    // Pagination,
    Multiselect,
    CustomDataTable,
    AttendancePagesHeading,
    BulkDisburseFromExcel,
    EditBill
  },
  props: ['swal', 'alert'],
  data() {
    return {
      paginationValue: '20',
      totalPages: 0,
      total: 0,
      currentPage: 1,
      perPage: 0,
      pageCount: '',
      to: 0,
      from: 0,
      paymentList: [],
      selectedPayment: {},
      paginatedFilteredPaymentList: [],
      isLoading: true,
      selected: [],
      driverDetails: [],
      driverDetailsObj: {},
      disbursementStatusDetails: [],
      filterOption: [
        'Name',
        'Phone',
        'Account No',
        'Client',
        // 'Bill Type',
        'Transaction ID'
        // 'Payment Method',
      ],
      filterValues: {
        bill_type: 'regular',
        payment_method: 'bkash'
      },
      selectFilter: '',
      searchUserCode: [],
      searchValue: ''
    };
  },
  watch: {
    searchValue: {
      handler: function () {
        if (this.selectFilter === 'Name') {
          // let url = `v1/users/search?field=name&return=mobile,name,user_code&key=${this.searchValue}&limit=50`;
          // this.searchData(url);
          this.getPaymentList();
        }

        if (this.selectFilter === 'Phone') {
          // let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.searchValue}&limit=50`;
          // this.searchData(url);
          this.getPaymentList();
        }

        if (this.selectFilter.replaceAll(' ', '_') === 'Account_No') {
          this.getPaymentList();
        }

        if (this.selectFilter === 'Client') {
          this.getPaymentList();
        }

        if (this.selectFilter === 'Transaction ID') {
          this.getPaymentList();
        }

        // if (this.selectFilter === 'Payment Method') {
        //   this.getPaymentList();
        // }

        // if (this.selectFilter === 'Bill Type') {
        //   this.getPaymentList();
        // }
      },
      deep: true
    },
    paginationValue: {
      handler: function () {
        this.getPaymentList();
      },
      deep: true
    },
    selectFilter: {
      handler: function () {
        this.searchValue = '';
      },
      deep: true
    },
    filterValues: {
      handler: function () {
        this.getPaymentList();
      },
      deep: true
    }
  },
  mounted() {
    this.getPaymentList();
  },
  computed: {
    formatDateUsingMoment() {
      return moment(this.$route.params.date).format('D MMMM YYYY');
    },
    selectAll: {
      get() {
        if (this.paymentList && this.paymentList.length > 0) {
          // A paymentList array exists with at least one item
          let allChecked = true;

          for (const list of this.paymentList) {
            if (!this.selected.includes(list.transaction_history_id)) {
              allChecked = false; // If even one is not included in array
            }

            // Break out of loop if mismatch already found
            if (!allChecked) break;
          }

          return allChecked;
        }

        return false;
      },
      set(value) {
        const checked = [];

        if (value) {
          this.paymentList.forEach((list) => {
            checked.push(list.transaction_history_id);
          });
        }

        this.selected = checked;
      }
    },

    getDisburseOnDate() {
      return this.paymentList
        .map(function (e) {
          return e.disbursed_on;
        })
        .sort()
        .reverse()[0];
    },
    checkAllPaymentDisbursed() {
      var count = 0;
      this.paymentList.forEach((data) => {
        if (data.total_bill_requested_and_disbursed === 2) {
          count += 1;
        }
      });

      if (this.paymentList.length != count) {
        return true;
      } else {
        return false;
      }
    },
    totalDisbursementStatus() {
      let status = 'Pending';
      let disbursementCount = 0;

      if (this.paymentList.length <= 0) {
        return '';
      }

      this.paymentList.forEach((disbursement) => {
        if (disbursement.total_bill_requested_and_disbursed === 2) {
          disbursementCount++;
          status = 'Partially Disbursed';
        }
      });

      if (this.paymentList.length <= disbursementCount) {
        status = 'Disbursed';
      }

      return status;
    },
    latestDisbursementDate() {
      let dateString = 'N/A';
      let disburseDate = null;

      this.paymentList.forEach((disbursement) => {
        if (disbursement.disbursed_on) {
          let disbursedOn = new Date(disbursement.disbursed_on);
          if (disburseDate) {
            if (disbursedOn > disburseDate) {
              disburseDate = disbursedOn;
            }
          } else {
            disburseDate = disbursedOn;
          }
        }
      });

      if (disburseDate) {
        dateString = disburseDate.toLocaleDateString('en-GB');
      }

      return dateString;
    },
    filteredPaymentList() {
      let filteredPayments = this.paymentList;
      let selectedParam = null;

      if (this.selectFilter === 'Name') {
        selectedParam = 'name';
      } else if (this.selectFilter === 'Phone') {
        selectedParam = 'mobile';
      }

      if (selectedParam && this.searchValue) {
        filteredPayments = this.paymentList.filter((bill) => {
          if (this.driverDetailsObj[bill.user_code]) {
            if (
              this.driverDetailsObj[bill.user_code][selectedParam]
                .toLowerCase()
                .indexOf(this.searchValue.toLowerCase()) > -1
            ) {
              return true;
            }
            return false;
          }
          return false;
        });
      }

      return filteredPayments;
    }
  },
  methods: {
    fetchPaginatedData(paginatedData) {
      this.paginatedFilteredPaymentList = paginatedData;
    },
    searchData(url) {
      this.searchUserCode = [];
      userService
        .get(url)
        .then((response) => {
          let user_info = response.data.data;
          user_info.forEach((users) => {
            this.searchUserCode.push(users.user_code);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    floatingPointPlaces(value, places) {
      let refinedValue = value;
      if (typeof value === 'number') {
        let splittedValue = value.toString().split('.');
        if (splittedValue.length == 2 && splittedValue[1].length > places) {
          splittedValue[1] = splittedValue[1].slice(0, places);
          refinedValue = splittedValue.join('.');
        }
      }
      return refinedValue;
    },
    downloadExcelFile() {
      var url;
      url = `v2/partners/transaction/disbursement/export?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      if (this.selectFilter.replaceAll(' ', '_') === 'Account_No') {
        url = `v2/partners/transaction/disbursement/export?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&account_no=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      } else if (this.selectFilter === 'Client') {
        url = `v2/partners/transaction/disbursement/export?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&client=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      } else if (this.selectFilter === 'Transaction ID') {
        url = `v2/partners/transaction/disbursement/export?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&transaction_code=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      }

      http
        .get(url, { responseType: 'arraybuffer' })
        .then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            'download',
            `payment_disbursement_list_${this.$route.params.date}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    disbursementAmount() {
      let paymentArray = [];

      this.selected.forEach((data) => {
        paymentArray.push({
          transaction_history_id: data,
          status: 'disbursed'
        });
      });

      let data = {
        disbursed_transactions: paymentArray
      };

      http
        .patch(`/v2/partners/transaction/history`, data)
        .then((response) => {
          if (response.status === 200) {
            this.selected = [];
            this.$swal({
              icon: 'success',
              title: 'Congratulations!',
              text: 'Payment disbursed successfully!'
            });
            this.getPaymentList();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
    getPaymentList() {
      var url;
      if (this.selectFilter.replaceAll(' ', '_') === 'Account_No') {
        url = `/v2/partners/transaction/requested-bills?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&account_no=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      } else if (this.selectFilter === 'Client') {
        url = `/v2/partners/transaction/requested-bills?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&client=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      } else if (this.selectFilter === 'Transaction ID') {
        url = `/v2/partners/transaction/requested-bills?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&transaction_code=${this.searchValue}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      } else {
        url = `/v2/partners/transaction/requested-bills?transaction_date_starts=${this.$route.params.date}&transaction_date_ends=${this.$route.params.date}&user_code=${this.searchUserCode}&service_type=${this.$route.params.serviceType}&type=${this.filterValues.bill_type}&payment_method=${this.filterValues.payment_method}`;
      }

      this.isLoading = true;
      http
        .get(url)
        .then((response) => {
          if (response.status === 200) {
            this.paymentList = response.data.data;
            // this.total = response.data.total;
            // this.totalPages = response.data.last_page;
            // this.currentPage = response.data.current_page;
            // this.perPage = response.data.per_page;
            // this.to = response.data.to;
            // this.from = response.data.from;
            // this.disbursementStatusDetails =
            //   response.data.data.disbursementStatus;

            let userCodes = [];
            this.paymentList.forEach((ele) => {
              userCodes.push(ele.user_code);
              userCodes.push(ele.driver);
            });
            this.getDriverDetails(userCodes);

            // this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
          this.isLoading = false;
        });
    },
    getDriverDetails(id) {
      userService
        .get(
          `v1/users?user_code=${id.join(
            ','
          )}&fields=name,mobile,user_code,email,status&limit=500`
        )
        .then((response) => {
          this.driverDetails = response.data.data;
          this.isLoading = false;
          this.mapDriverDetailsIntoObject();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mapDriverDetailsIntoObject() {
      this.driverDetails.forEach((driver) => {
        this.driverDetailsObj[driver.user_code] = driver;
      });
    }
  }
};
</script>

<style scoped>
.cell h6 {
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 4px;
}
.cell p {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0;
}
.download-button {
  cursor: pointer;
  color: #652f8f;
}
.download-button:hover {
  cursor: pointer;
  color: #a95eea;
}
.partner-card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.partner-card .card-header .button-area {
  display: flex;
  justify-content: end;
  align-items: center;
  flex-wrap: wrap;
}
.partner-card .card-header .button-area > * {
  margin-left: 1rem;
}
.multiselect {
  min-width: 150px;
  margin-right: 0;
}

.disbursed-rectangle {
  background-color: #d9ffd9;
  color: #00ab30;
}

.partially-disbursed-rectangle {
  background-color: #d9dfff;
  color: #0a30ef;
}

.pending-rectangle {
  background-color: #ffecde;
  color: #fd9144;
}

table {
  font-size: 14px;
}

/*table thead th {*/
/*  background-color: #F3F3F3;*/
/*}*/
</style>
